import {useEffect} from 'react'
import {setBasicProperties} from '@helpers/posthog'
import {posthogDev, posthogProd, urlPosthogDev, urlPosthogProd} from '@helpers/posthog/config'
import getEnv from '@providers/getEnv'
import {useRouter} from 'next/router'
import posthog from 'posthog-js'

export default function usePosthog({pageProps}) {
  const router = useRouter()
  useEffect(() => {
    // Init PostHog
    posthog.init(getEnv() === 'prod' ? posthogProd : posthogDev, {
      api_host: getEnv() === 'prod' ? urlPosthogProd : urlPosthogDev
    })

    // if need to test new events please remove this if
    if (getEnv() === 'local') {
      posthog.opt_out_capturing()
    } else {
      posthog.clear_opt_in_out_capturing()
    }
    setBasicProperties({...pageProps.website})

    // Track page views
    const handleRouteChange = () => posthog.capture('$pageview')
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])
  return null
}

export const WithPosthog = ({pageProps, children}) => {
  usePosthog({pageProps})
  return children
}
